/**
 * 処理後物
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/recycle_disposed_items`

const getDefaultState = () => {
  return {}
}

const master_recycle_disposed_item = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {
    /**
     * 処理後物一覧取得
     * @param commit
     * @param state
     * @param after_type
     * @param code
     * @param without_invisible
     * @param page
     * @param limit
     * @param format
     * @param useState
     */
    index ({ commit, state }, { after_type, code, without_invisible, page, limit, format, useState = true }) {
      let api_path
      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      const params = { after_type: after_type, code: code, without_invisible: without_invisible, page: page, limit: limit }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format !== 'csv') {
            resolve(data.content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new ({ commit }) {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.post(API_PATH, params).then(data => {
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.put(api_path, params).then(data => {
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    destroy ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        let content = {};
        Vue.$http.delete(`${API_PATH}/${id}`).then(data => {
          let content = data.content;
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(content)
        })
      })
    },
  },
  mutations: {
  },
}

export default master_recycle_disposed_item
